import { useMemo } from "react";

import {
  ProductDropDownList,
  RecordStatus,
  RecordStatusDropdown,
} from "@components/custom/dropdowns";

import { ProfessionalLearningProduct } from "@components/custom/dropdowns/product-dropdown-list";

import { ClassroomsSearchbox } from "@views/classrooms/list/components";

import "./classrooms.filters.scss";

export function ClassroomsFilters({
  onFiltersChange,
  filters,
  data = [],
  searchTerm,
  onSearchTermChange,
  selectedProduct,
  onProductSelected,
  status = RecordStatus.Active,
  onStatusChange,
  showStatusDropdown,
}) {
  const availableProducts = useMemo(() => {
    const products = [...new Set(data.flatMap((c) => c.products))].sort();
    if (data.some((c) => c.isProfessionalLearning)) {
      products.push(ProfessionalLearningProduct);
    }
    return products;
  }, [data]);

  return (
    <div className="classrooms-filters">
      <ClassroomsSearchbox
        onSearch={onFiltersChange}
        data={data}
        filters={filters}
        searchTerm={searchTerm}
        onSearchTermChange={onSearchTermChange}
      />
      {availableProducts.length > 1 && (
        <ProductDropDownList
          placeholder="Filter by product"
          products={availableProducts}
          clearEnabled
          selectedProduct={selectedProduct}
          onProductSelected={(product) => {
            onProductSelected?.(product);
          }}
          combineCeTrek
        />
      )}
      {showStatusDropdown && (
        <RecordStatusDropdown
          className="classroom-status-dropdown"
          selected={status}
          onChange={onStatusChange}
        />
      )}
    </div>
  );
}
